import { Controller } from "@hotwired/stimulus";
import { application } from "src";
import { toSeconds } from "@fretadao/f-js-utils";

// This controller is used to display a countdown timer on the textContent of the element,
// given the time in seconds on data attribute, formatted in mm:ss.
// @example:
// <button
//   data-controller="countdown-and-enable-button"
//   data-countdown-and-enable-button-expires-at-value="2025-02-03T12:38:55.766-03:00"
//   data-countdown-and-enable-button-expires-in-seconds-value="10"
//   data-countdown-and-enable-button-text-value="Click me"
//   data-countdown-and-enable-button-href-value="/path"
// ></button>
application.register("countdown-and-enable-button", class extends Controller {
  static values = {
    expiresAt: String,
    expiresInSeconds: Number,
    text: String,
    href: String
  };

  connect() {
    if (this.hasExpiresAtValue && !this.hasExpiresInSecondsValue) {
      const now = new Date().getTime();
      const expiresAtInMs = this.#parseDate(this.expiresAtValue);

      this.expiresInSecondsValue = toSeconds(expiresAtInMs - now, 'milliseconds');
    }
    this.update();
  }

  update() {
    const minutes = String(Math.floor(this.expiresInSecondsValue / 60)).padStart(2, '0');
    const seconds = String(this.expiresInSecondsValue % 60).padStart(2, '0');
    this.element.textContent = `${minutes}:${seconds}`;

    setTimeout(this.#tick.bind(this), 1000);
  }

  #tick() {
    if (this.expiresInSecondsValue > 0) {
      this.expiresInSecondsValue--;
      this.update();
    } else {
      this.element.textContent = this.textValue;
      this.element.disabled = false;
      this.element.href = this.hrefValue;
    }
  }

  // Date.parse or new Date() may not work correctly in some browsers (iOS)
  #parseDate(dateString) {
    let date = new Date(dateString);

    if (isNaN(date.getTime())) {
      const [year, month, day, hour, minute, second] = dateString.split(/[- :]/);
      date = new Date(year, month - 1, day, hour, minute, second);
    }

    return date.getTime();
  }

});
